@if (!settingsMenuActivated) {
    <div class="map-button burger-menu" (click)="openSettingsMenu()">
        <ev-tooltip-simple class="tooltip" text="Kartinnstillinger"></ev-tooltip-simple>
    </div>
} @else {
    <div class="map-button burger-menu">
        <div class="burger-menu-content" (clickOutside)="closeSettingsMenu()">
            @for(layer of wmsLayers(); track layer) {
            <div class="map-button burger-menu-item" (click)="addRemoveLayer(layer)">
                <div class="map-button text-container">
                    <span class="button-text">{{ layer.description }}</span>
                </div>
                <div class="toggle-container">
                    <ev-toggle [active]="layer.selected" [style]="ToggleStyle.BRIGHT" [size]="20"></ev-toggle>
                </div>
            </div>
            }
            <div class="burger-menu-divider">
                <div class="divider"></div>
                <div class="bottom"></div>
            </div>
            @for(mapType of mapTypes.getAllTypes(); track mapType) {
            <div class="map-button burger-menu-item" (click)="switchMapMode(mapType)">
                <div class="map-button text-container" [ngClass]="{ selected: mapType.name === activeMapMode() }">
                    <span class="button-text">{{ mapType.description }}</span>
                </div>
            </div>
            }
            <div class="burger-menu-divider">
                <div class="divider"></div>
                <div class="bottom"></div>
            </div>
            <div class="map-button burger-menu-item" (click)="openMunicipalityMap()">
                <div class="map-button text-container">
                    <span class="button-text">Gå til kommunekart</span>
                </div>
                <div class="external-link-container">
                    <span class="external-link"></span>
                </div>
            </div>
            <div class="map-button burger-menu-item" (click)="openTopographyMap()">
                <div class="map-button text-container">
                    <span class="button-text">Gå til høydekart</span>
                </div>
                <div class="external-link-container">
                    <span class="external-link"></span>
                </div>
            </div>
            <div class="burger-menu-divider">
                <div class="divider"></div>
                <div class="bottom"></div>
            </div>
            <div class="map-button burger-menu-item" (click)="toggleEveryEstate()">
                <div class="map-button text-container">
                    <span class="button-text">Fritt eiendomsvalg</span>
                </div>
                <div class="toggle-container">
                    <ev-toggle [active]="anyEstateActive" [style]="ToggleStyle.BRIGHT" [size]="20"></ev-toggle>
                </div>
            </div>
            <div class="map-button burger-menu-item" (click)="toggleAreaChoice()">
                <div class="map-button text-container">
                    <span class="button-text">Vis områdevalg</span>
                </div>
                <div class="toggle-container">
                    <ev-toggle [active]="areaChoiceActive" [style]="ToggleStyle.BRIGHT" [size]="20"></ev-toggle>
                </div>
            </div>
            <div class="burger-menu-divider">
                <div class="divider"></div>
                <div class="bottom"></div>
            </div>
            <div class="map-button burger-menu-item" (click)="openGuide()">
                <div class="map-button text-container">
                    <span class="button-text">Guide</span>
                </div>
            </div>
        </div>
    </div>
}
